
let _ = require('../_.js');
let $ = jQuery;

// Helper functions for getting various properties of items, falling back to the auction description if it is a single
// item auction.

_.lib_items_get_photos_for_item = async function (item) {
    let auction_items = await (await item.auction.fetch()).auction_items.fetch();
    if (auction_items.length > 1) {
        let photos = item.photos.fetch();
        if (photos.length == 0) {
            return await (await item.property.fetch()).photos.fetch();
        } else {
            return photos;
        }
    } else {
        return await (await item.property.fetch()).photos.fetch();
    }
}

_.lib_items_get_featured_photo = async function (item) {
    let auction = await item.auction.fetch();
    let auction_items = await auction.auction_items.fetch();

    if (auction_items.length > 1) {
        // Try featured photo first
        let itemFeaturedPhoto = await item.featuredPhoto.fetch();

        if (itemFeaturedPhoto) {
            return itemFeaturedPhoto;
        }

        // If not that, do first photo
        let photos = await item.photos.fetch();
        if (photos.length != 0) {
            return photos[0];
        }
    }

    let property = await auction.property.fetch();

    let propertyFeaturedPhoto = property.featuredPhoto.fetch();
    if (propertyFeaturedPhoto) {
        return propertyFeaturedPhoto;
    }

    let propertyPhotos = await property.photos.fetch();

    if (propertyPhotos.length > 0 && propertyPhotos[0]) {
        return propertyPhotos[0];
    }

    return null;
}

_.lib_items_get_breif_description = async function (item) {
    let auction = await item.auction.fetch();
    let auction_items = auction.auction_items.fetch();

    if (auction_items.length > 1) {
        let desc = item.brief_description;
        if (desc) {
            return desc;
        }
    }

    return (await auction.property.fetch()).brief_description;
}
